import { FC, useEffect, useState } from 'react';
import PCCom from '../../components/PCCom';
import H5Com from '../../components/H5Com';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const TheComp: FC = () => {
    const { t } = useLang('dp3.teaser.Member');
    const [isPC, setIsPC] = useState(true);
    const { locale } = getLocal();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsPC(window.innerWidth > 1024);
        }
    }, []);

    return (
        <div id="dp3-teaser-F" className={`dp3-module-box dp3-teaser-F`}>
            {isPC ? (
                <PCCom
                    title={t('title')}
                    img={
                        locale === 'jp'
                            ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717750088453/Frame%201000007972%20(1).png'
                            : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717762033714/ab1-w.png'
                    }
                    subtitle={t('lMsg')}
                    desc={t('rMsg')}
                />
            ) : (
                <H5Com
                    title={t('title')}
                    imgArr={
                        locale === 'jp'
                            ? [
                                  'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717755706263/tt3%202.jpg',
                                  'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717755793809/bb1.jpg',
                              ]
                            : [
                                  'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717760171944/tt31.jpg',
                                  'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717760271479/tt4%20(1).jpg',
                                  'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717760352900/aa1%20(1).jpg',
                              ]
                    }
                    subtitle={t('lMsg')}
                    desc={t('rMsg')}
                    cls="dp3-teaser-F"
                />
            )}
        </div>
    );
};

export default TheComp;
